import {
  Component,
  ViewChild,
  ElementRef,
  Output,
  Input,
  EventEmitter,
  Renderer2
} from '@angular/core';
import {
  Participant,
  RemoteTrack,
  RemoteAudioTrack,
  RemoteVideoTrack,
  RemoteParticipant,
  RemoteTrackPublication
} from 'twilio-video';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-participants',
  styleUrls: ['./participants.component.css'],
  templateUrl: './participants.component.html',
})
export class ParticipantsComponent {
  @ViewChild('list') listRef: ElementRef;
  @Output('participantsChanged') participantsChanged = new EventEmitter<boolean>();
  @Output('leaveRoom') leaveRoom = new EventEmitter<boolean>();
  @Input('activeRoomName') activeRoomName: string;
  @Input() role = "";
  @Input() isMinimize: boolean = false
  get participantCount() {
    return !!this.participants ? this.participants.size : 0;
  }

  get isAlone() {
    return this.participantCount === 0;
  }

  private participants: Map<Participant.SID, RemoteParticipant>;
  private dominantSpeaker: RemoteParticipant;

  constructor(private readonly renderer: Renderer2,
    private route: ActivatedRoute) { }

  clear() {
    if (this.participants) {
      this.participants.clear();
    }
    // clear all the video tracks
    if (document.getElementById('list')) {
      document.getElementById('list').innerHTML = "";
    }
  }

  initialize(participants: Map<Participant.SID, RemoteParticipant>) {
    this.participants = participants;
    if (this.participants) {
      this.participants.forEach(participant => this.registerParticipantEvents(participant));
    }
  }

  add(participant: RemoteParticipant) {
    if (this.participants && participant) {
      this.participants.set(participant.sid, participant);
      this.registerParticipantEvents(participant);
    }
  }

  remove(participant: RemoteParticipant) {
    if (participant && participant.tracks && participant.sid && this.checkIfOnlyAudioTrack(participant.videoTracks)) this.removeAudioHtml(participant.sid);
    if (this.participants && this.participants.has(participant.sid)) {
      this.participants.delete(participant.sid);
    }
  }

  loudest(participant: RemoteParticipant) {
    this.dominantSpeaker = participant;
  }

  onLeaveRoom() {
    this.leaveRoom.emit(true);
  }

  private registerParticipantEvents(participant: RemoteParticipant) {
    if (participant) {
      participant.tracks.forEach(publication => this.subscribe(publication));
      // if only audio track is present then add named html
      if (this.checkIfOnlyAudioTrack(participant.videoTracks)) {
        this.addAudioHtml(participant.sid);
      };
      participant.on('trackPublished', publication => this.subscribe(publication));
      participant.on('trackUnpublished',
        publication => {
          if (publication && publication.track) {
            this.detachRemoteTrack(publication.track);
          }
        });
    }
  }

  private addAudioHtml(sid) {
    const child = document.createElement('div');
    child.setAttribute("id", sid);
    let domString = `<div 
    style=\"height: 200px; justify-content: center!important; display: flex;flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;\">
      <div style=\" margin-bottom: auto!important;margin-top:auto!important;\">
      <div style = \"     background-color: #ccc;
      border-radius: 50%;
      height: 6rem;
      text-align: center;
      width: 6rem;\">
      <span style = \"font-size: calc(3rem/ 2);
      line-height: 1;
      position: relative;
      top: calc(6em / 4);\">${this.participantInitials()}</span></div></div></div>
      `;
    child.innerHTML = domString;
    document.getElementById("list").appendChild(child);
  }

  public participantInitials() {
    let self = this.role != "" ? this.role : this.route.snapshot.params["role"];
    let paricipantRole;
    switch (self) {
      case 'pat':
        paricipantRole = 'doctor';
        break;
      case 'dr':
        paricipantRole = 'patient';
        break;
    }
    return paricipantRole;
  }

  private removeAudioHtml(sid) {
    let html = document.getElementById(sid);
    html.remove();
  }

  private checkIfOnlyAudioTrack(track) {
    if (track && track.size && track.size > 0) {
      return false;
    }
    return true;
  }


  private subscribe(publication: RemoteTrackPublication | any) {
    if (publication && publication.on) {
      publication.on('subscribed', track => this.attachRemoteTrack(track));
      publication.on('unsubscribed', track => this.detachRemoteTrack(track));
    }
  }

  private attachRemoteTrack(track: RemoteTrack) {
    if (this.isAttachable(track)) {
      const element = track.attach();
      this.renderer.data.id = track.sid;
      this.renderer.setStyle(element, 'width', '100%');
      this.renderer.setStyle(element, 'height', '600px');
      this.renderer.setStyle(element, 'object-fit', 'cover');
      // this.renderer.setStyle(element, 'margin-top', '11px');
      this.renderer.appendChild(this.listRef.nativeElement, element);
      this.participantsChanged.emit(true);
    }
  }

  private detachRemoteTrack(track: RemoteTrack) {
    if (this.isDetachable(track)) {
      track.detach().forEach(el => el.remove());
      this.participantsChanged.emit(true);
    }
  }

  private isAttachable(track: RemoteTrack): track is RemoteAudioTrack | RemoteVideoTrack {
    return !!track &&
      ((track as RemoteAudioTrack).attach !== undefined ||
        (track as RemoteVideoTrack).attach !== undefined);
  }

  private isDetachable(track: RemoteTrack): track is RemoteAudioTrack | RemoteVideoTrack {
    return !!track &&
      ((track as RemoteAudioTrack).detach !== undefined ||
        (track as RemoteVideoTrack).detach !== undefined);
  }
}